// posts filter form
const form = document.getElementById('post-filter');

// on form submit go to url
if (form) {
  form.addEventListener('submit', function (event) {
    event.preventDefault();

    // get selected option value
    const category = document.getElementById('category').value;

    // go to url
    window.location.href = category;
  });
}
